import { em } from 'polished'
import styled from 'styled-components'

import DynamicImage from 'components/DynamicImage'
import SectionWrapper from 'components/SectionWrapper'

export const SectionWrapperStyled = styled(SectionWrapper)`
  background-color: ${p =>
    p.bgColor === 'purple' ? p.theme.colors.purpleHeart : p.theme.colors.lilac};
  ${p => p.theme.mq.upLg} {
    display: flex;
    align-items: center;
    min-height: ${p => p.theme.blocks.heightBlockSquares};
  }
`

export const SquaresBoxMd = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: flex-end;
  z-index: 10;
`

export const SquaresBox = styled.div`
  display: block;
  margin-left: -${p => p.theme.indents.baseIndentXs};
  margin-right: -${p => p.theme.indents.baseIndentXs};

  ${p => p.theme.mq.upMd} {
    margin-left: 0;
    margin-right: 0;
    display: flex;
    justify-content: center;
  }

  ${p => p.theme.mq.upLg} {
    display: none;
  }
`

export const IconWrapper = styled.div`
  width: ${p => em(p.width)};
  height: ${p => em(p.height)};
  display: inline-block;
  margin-right: ${em(20)};
  vertical-align: middle;
`

export const ImgIso = styled(DynamicImage)`
  display: block;
  width: 100%;
  height: auto;
`

export const ArticleStyled = styled.article`
  padding-top: ${em(40)};
  padding-bottom: ${em(40)};
  max-width: 100%;

  ${p => p.theme.mq.upMd} {
    max-width: 80%;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
  }

  ${p => p.theme.mq.upLg} {
    margin-left: 0;
    margin-right: 0;
    padding-top: 0;
    padding-bottom: 0;
    text-align: left;
  }
`
